import { LongUrlRetrieverService } from '@ampcore/client-side-services'
import React from 'react'

import { RedirectorShortUrlConfig } from './Redirector.type'

export type ShortUrlRedirectorProps = Omit<RedirectorShortUrlConfig, 'variant'>

export const ShortUrlRedirector: React.FC<ShortUrlRedirectorProps> = ({
  shortUrl
}) => {
  React.useEffect(() => {
    if (shortUrl) {
      const longUrlRetrieverService = new LongUrlRetrieverService()
      longUrlRetrieverService
        .send(shortUrl)
        .then((response: string | null) => {
          if (response) {
            window.location.replace(response)
          } else {
            throw new Error()
          }
        })
        .catch(() => {
          console.error('Failed to retrieve long URL')
          window.location.replace('/error')
        })
    }
  }, [shortUrl])
  return null
}
